import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=6c6b017d&scoped=true&"
import script from "./Collapse.vue?vue&type=script&lang=js&"
export * from "./Collapse.vue?vue&type=script&lang=js&"
import style0 from "./Collapse.vue?vue&type=style&index=0&id=6c6b017d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b017d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c6b017d')) {
      api.createRecord('6c6b017d', component.options)
    } else {
      api.reload('6c6b017d', component.options)
    }
    module.hot.accept("./Collapse.vue?vue&type=template&id=6c6b017d&scoped=true&", function () {
      api.rerender('6c6b017d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Collapse.vue"
export default component.exports